import "./hero.css";

export default function Hero() {
  return (
    <section className="Hero" id="accueil">
      <div className="hero__clr-bg"></div>
      <article>
        {/* <h1>Nice Plomberie</h1> */}
        <h2>
          {/*Dépannage - Travail sur cordes*/} Plomberie - Chauffage -
          Climatisation - Chemisage - Travaux Acrobatique - Accès difficiles
        </h2>
        <p>
          Depuis plus de sept décennies, nous mettons notre expertise au service
          de vos installations de plomberie, de la rénovation sans démolition
          par chemisage et des interventions en hauteur par travaux sur cordes.
        </p>
        <p>
          Une équipe qualifiée, des équipements modernes et un engagement total
          pour votre satisfaction et la durabilité de vos installations.
        </p>
        <a href="#contact" className="button">
          Nous contacter
        </a>
      </article>
    </section>
  );
}
